function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-/-social-/-youtube",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(14.000000, 16.000000)",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.7871631,0.538898146 C14.380449,0.179632715 20.0428705,0 25.7744276,0 C31.5830594,0 37.3917798,0.184496389 43.2005889,0.553489167 L43.2005891,0.553485826 C47.766761,0.843542605 51.3886356,4.51333566 51.618655,9.08292534 C51.872885,14.1334838 52,19.1477768 52,24.1258041 C52,29.06388 51.8749172,34.0019332 51.6247515,38.9399638 L51.624753,38.9399638 C51.3934623,43.5054214 47.7764177,47.172285 43.214551,47.4660031 C37.6853893,47.822001 32.0565747,48 26.3281072,48 C20.4852661,48 14.6423019,47.8148223 8.79921437,47.4444669 L8.79921419,47.4444697 C4.23261406,47.1550226 0.610069205,43.4851544 0.379912849,38.9151824 C0.126637616,33.8861632 0,28.8836593 0,23.9076706 C0,18.9602638 0.125186996,14.0128742 0.375560987,9.06550176 L0.375563935,9.06550191 C0.60664659,4.49932493 4.22454491,0.831962192 8.7871631,0.538898146 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  transform: "translate(28.600000, 24.000000) rotate(-270.000000) translate(-28.600000, -24.000000) ",
  points: "28.6 15.6 37.6 32.4 19.6 32.4"
})));

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.b0af88bc.svg";
export { ForwardRef as ReactComponent };